import {
  STORAGE_KEY_REFRESHED_AT,
  STORAGE_KEY_SERVICE_ID,
  STORAGE_KEY_SERVICE_NAME,
} from '../../constants/storage';
import { valtioDevTools } from '@lib/utils/devTools';
import { proxy, subscribe } from 'valtio';
import { AuthState } from './types';

function getInitialState(): AuthState {
  const serviceId = localStorage.getItem(STORAGE_KEY_SERVICE_ID) || '';
  const serviceName = localStorage.getItem(STORAGE_KEY_SERVICE_NAME) || '';
  const refreshedAt = parseInt(
    localStorage.getItem(STORAGE_KEY_REFRESHED_AT) ?? '0',
    0,
  );

  return {
    loading: false,
    loadingState: 'none',
    signedIn: false,
    refreshedAt,
    token: '',
    user: undefined,
    serviceId,
    serviceName,
    error: undefined,
  };
}

export const authState = proxy<AuthState>(getInitialState());

valtioDevTools(authState, 'authState');

subscribe(authState, () => {
  localStorage.setItem(STORAGE_KEY_SERVICE_ID, authState.serviceId || '');
  localStorage.setItem(STORAGE_KEY_SERVICE_NAME, authState.serviceName || '');
  localStorage.setItem(
    STORAGE_KEY_REFRESHED_AT,
    authState.refreshedAt.toString(),
  );
});
